import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PdfPage from './PdfPage';
import QuizPage from './QuizPage';
import { useNavigate } from 'react-router-dom';
import CourseNavigation from './course-navigation/CourseNavigation';
import Assessment from './Assessment';
import Assignment from './Assignment';
import { getCourseActivity } from '../../../../../helper/api.helper';
import toast from 'react-hot-toast';
import Loader from '../../../../../components/loader/Loader';
import CourseVideo from './course-video/CourseVideo';
import { courseSectionTypeEnum } from '../../../../../helper/constants.helper';
import { getOrgCode } from '../../../../../helper/utils.helper';

const Course = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visitedPages, setVisitedPages] = useState(() => {
    const saved = localStorage.getItem(`visitedPages${id}`);
    return saved ? JSON.parse(saved) : {};
  });

  useEffect(() => {
    localStorage.setItem(`visitedPages${id}`, JSON.stringify(visitedPages));
  }, [visitedPages, id]);

  useEffect(() => {
    const orgCode = getOrgCode();
    getCourseActivity(orgCode, id)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setSelectedCourse(res.data);
        } else {
          toast.error(res.message);
          navigate('/');
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [id]);

  const sections = selectedCourse?.course?.sections;
  const activeSection = sections?.[activeIndex];

  return (
    <div
      style={{
        padding: 'var(--space-sm)'
      }}
      className="course-wrapper ">
      {!selectedCourse ? (
        <Loader />
      ) : (
        <div className="course-outer-div flex-container direction-column align-center">
          <h2>{selectedCourse.course.name}</h2>
          <div className="course-inner-div margin-top--lg">
            <CourseNavigation
              sections={sections}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              visitedPages={visitedPages}
              setVisitedPages={setVisitedPages}
            />
            {activeSection?.type === courseSectionTypeEnum.VIDEO && (
              <CourseVideo
                key={activeSection.id}
                courseActivityId={id}
                section={activeSection}
                setVisitedPages={setVisitedPages}
              />
            )}
            {activeSection?.type === courseSectionTypeEnum.SLIDES && (
              <PdfPage section={activeSection} setVisitedPages={setVisitedPages} />
            )}
            {activeSection?.type === courseSectionTypeEnum.ASSESSMENT && (
              <Assessment
                key={activeSection.id}
                section={activeSection}
                courseActivityId={id}
                setVisitedPages={setVisitedPages}
              />
            )}
            {activeSection?.type === courseSectionTypeEnum.QUIZ && (
              <QuizPage
                key={activeSection.id}
                section={activeSection}
                setVisitedPages={setVisitedPages}
                courseActivityId={id}
              />
            )}
            {activeSection?.type === courseSectionTypeEnum.ACTIVITY && (
              <Assignment
                key={activeSection.id}
                section={activeSection}
                setVisitedPages={setVisitedPages}
                courseActivityId={id}
              />
            )}
          </div>
        </div>
      )}
      <style jsx>
        {`
          .course-wrapper {
            min-height: 87vh;
          }
          .course-outer-div {
            margin: auto;
            max-width: 900px;
          }
          .course-inner-div {
            border: 1px solid lightgrey;
            width: 100%;
          }
          @media only screen and (max-width: 600px) {
            .course-inner-div {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Course;
